import type { Day } from '../hooks/useCalendarScales';
import { format } from '../../../utils/formatting';
import { calendarTimezone } from '../utils';

interface DayHeaderProps {
    days: Day[];
    buildMode?: boolean;
}

// Handles the display of day names and dates in the left column.
export function DayHeader({ days, buildMode = false }: DayHeaderProps): JSX.Element {
    return (
        <div className={`${buildMode ? 'mt-9' : 'mt-2.5'} w-24 font-bold`}>
            {days.map(({ name, start, key }) => (
                <div key={key} className="h-20 pb-12 pt-7 text-xs uppercase">
                    {name}
                    {!buildMode && (
                        <div className="text-2xs text-menu-color">
                            {format(start, { timezone: calendarTimezone, hideTime: true })}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}
